<template>
    <generico
        :endpoint-proposta="endpointProposta"
        :nome-id-projeto="nomeIdProjeto"
        :projeto-id-base="projetoIdBase"
        :projeto-id="projetoId"
        :projeto="projeto"
        :objeto="objeto[tela]"
        :chave-permissao="chavePermissao"
        @update="update"
        :projeto-editavel="projetoEditavel"
    />
</template>
<script>
import Generico from "../componentes/Generico.vue";
export default {
    props : {
        tela : {
            type : String
        },
        projetoId: {
            type: String,
            required: true
        },
        projetoIdBase: {
            type: String,
            required: true
        },
        nomeIdProjeto : {
            type: String,
            required: true
        },
        endpointProposta: {
            type: String,
            required: true
        },
        chavePermissao: {
            type: String,
            required: true
        },
        projeto : {
            required : true
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components : {
        Generico
    },
    data : () => ({
        objeto : {
            st : {
                tipo : 'tipoServico',
                rubrica : 'servico-terceiro',
                titulo : 'Serviços de Terceiros'
            },
            mc : {
                tipo : 'tipoMaterial',
                rubrica : 'material-consumo',
                titulo : 'Material de Consumo'
            },
            mpe : {
                tipo : 'tipoMaterial',
                rubrica : 'material-permanente',
                titulo : 'Materiais Permanentes e Equipamentos'
            },
            vd : {
                tipo : 'tipoViagem',
                rubrica : 'viagem-diaria',
                titulo : 'Viagens e Diárias'
            },
            ou : {
                tipo : 'tipoRecurso',
                rubrica : 'outro-recurso',
                titulo : 'Outros'
            },
        }
    }),
    methods : {
        update : function(){
            this.$emit("update");
        }
    }
}
</script>
<style lang="">
    
</style>